import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useGlobalMutation, useGlobalQuery } from '@/state/query-client/hooks';
import { useToast } from '@/hooks/use-toast';
import { getKpiConfiguration, saveKpiConfiguration } from '../services/kpi-configuration.service';
import { KpiConfigurationFormValues } from '../schemas/kpi-configuration-form-schema';

export const useGetKpiConfiguration = () => {
  return useGlobalQuery({
    queryKey: ['hr-kpi-configuration'],
    queryFn: () => getKpiConfiguration(),
    staleTime: 5 * 60 * 1000,
  });
};

export const useSaveKpiConfiguration = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation();

  return useGlobalMutation({
    mutationFn: (values: KpiConfigurationFormValues) => saveKpiConfiguration(values),
    // Returned so the mutation stays pending until the new row is read back into the form.
    onSuccess: async () => {
      // Performance dashboards score against the newest configuration, so their cached results are stale too.
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['hr-kpi-configuration'] }),
        queryClient.invalidateQueries({ queryKey: ['hr-performance-dashboard'] }),
      ]);
      toast({ title: t('KPI_CONFIGURATION_UPDATED') });
    },
  });
};
